import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { GenericCheckbox } from '../../components';
import { InputModel } from '../../models';
import { InputWithoutSource } from '../../componentTypes';

const SpecialTerminationIsRunOffInput: InputWithoutSource = ({ input }) => <GenericCheckbox label={input.name} input={input} />;

SpecialTerminationIsRunOffInput.meta = {
    inputType: InputModel.name
};

export default observer(SpecialTerminationIsRunOffInput);
